<template>
  <div
    v-if="item.text"
    :key="componentKey"
    :class="[$style.history_event_item, item.id === selectedItem?.id ? $style.active : '', item.azure_key ? '' : $style.not_ready_yet]"
    @click="clickItem"
  >
    <div :class="$style.history_event_item_icon">
      <div :class="additionalIcon" />
      <svg-sprite
        :name="getIcon"
      />
    </div>

    <div :class="$style.history_event_item_desc">
      <tooltip
        :content="taskName"
        position="top"
        :full-width="true"
        :delay="500"
        :hide="!hideTooltip"
        :class="$style.text_tooltip"
      >
        <template #body>
          <div
            :class="$style.history_event_item_text"
            v-html="item.text"
          />
        </template>
      </tooltip>

      <div :class="$style.history_event_item_date">
        {{ getDate }}
      </div>
    </div>

    <div :class="$style.history_event_item_user">
      <tooltip
        :content="item.user_name"
        :position="'left'"
        :full-width="true"
        :delay="500"
      >
        <template #body>
          <vgp-avatar
            :src="item.user_pic"
            custom-size="20"
          />
        </template>
      </tooltip>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import dateFormatHelper from '../../../helpers/dateFormatsHelper';
import tooltip from '../../common/VueComponents/tooltips/tooltip.vue';

export default {
  name: 'EventItem',
  components: {
    tooltip,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    selectedItem: {
      type: Object,
      default: null,
    },
  },
  emits: [
    'selectItem',
  ],
  data() {
    return {
      locales: __,
    };
  },
  computed: {
    componentKey() {
      const min = 1000;
      const max = 100000;

      return Math.floor(Math.random() * (max - min)) + min;
    },
    getIcon() {
      let icon = '';

      if (this.item.action_id === 71) {
        icon = 'task';
      } else {
        switch (~~(this.item.action_id / 10)) {
        case 17:
          icon = 'convertation';
          break;
        case 15:
          icon = 'checklist';
          break;
        case 16:

          icon = 'cascade-sorting';
          break;
        case 12:
          icon = 'template';
          break;
        case 11:
          icon = 'paste';
          break;
        case 10:
          if (this.item.action_description.data && this.item.action_description.data.eventName === 'status') {
            icon = 'status-1';
          } else if (this.item.action_description.data && this.item.action_description.data.eventName === 'priority') {
            icon = 'priority';
          }
          break;
        case 9:
          icon = 'history';
          break;
        case 7:
          // iconCSS = 'magic';
          // iconType = icon_magic;
          break;
        case 6:
          icon = 'task';
          break;
        case 8:
          icon = 'dragdrop';
          break;
        case 5:
          icon = 'assigned';
          break;
        case 4:
          icon = 'project';
          break;
        case 3:
          icon = 'project_name';
          break;
        case 1:
        case 2:
          icon = 'calendar';
          break;
        default:
          break;
        }
      }

      return icon;
    },
    getDate() {
      const date = moment(this.item.created_at);
      const userDateFormat = dateFormatHelper.getUserDateFormat();
      const userTimeFormat = dateFormatHelper.getUserTimeFormat();
      const timeFormat = userTimeFormat === 1 ? 'HH:mm' : 'hh:mm A';

      moment.locale(user.locale);

      const localeData = moment.localeData();

      const getCalendarText = (key, m = date) => {
        const template = localeData._calendar[key];

        if (typeof template === 'function') {
          return template.call(m, m).replace(/\s?LT/, '').trim();
        }
        if (typeof template === 'string') {
          return template.replace(/\s?LT/, '').trim();
        }

        return '';
      };

      return date.calendar(null, {
        sameDay: `${getCalendarText('sameDay')} ${timeFormat}`,
        lastDay: `${getCalendarText('lastDay')} ${timeFormat}`,
        lastWeek: `${getCalendarText('lastWeek')} ${timeFormat}`,
        sameElse: `${userDateFormat} ${timeFormat}`,
      });
    },
    taskName() {
      return this.item.action_description?.data.taskName ? this.item.action_description?.data.taskName : '';
    },
    hideTooltip() {
      return !!this.taskName;
    },
    isJira() {
      return this.item.action_description && this.item.action_description.data.isJira;
    },
    additionalIcon() {
      if (this.isJira) {
        return 'history-event-item-jira-icon';
      }
      if (this.item.withHash) {
        return 'history-event-item-g-icon';
      }

      return '';
    },
  },
  methods: {
    clickItem() {
      if (this.item.azure_key) {
        this.$emit('selectItem', this.item);
      }
    },
  },
};
</script>
<style src="../style.less" module></style>

<style lang="less" scoped>
.history-event-item-g-icon {
    position: absolute;
    height: 25px;
    width: 25px;
    left: 0px;
    background-image: url("https://cdn.ganttpro.com/app/imgs/history/g_label.svg");
    background-repeat: no-repeat;
    background-position-y: bottom;
    background-position-x: right;
}
.history-event-item-jira-icon {
    position: absolute;
    height: 25px;
    width: 25px;
    left: 0px;
    background-image: url("https://cdn.ganttpro.com/app/imgs/history/J_label.svg");
    background-repeat: no-repeat;
    background-position-y: bottom;
    background-position-x: right;
}

</style>
